export const ContainerTypeValues = {
  DEFAULT: 'default',
  SLIM: 'slim',
  ARTICLE: 'article',
  MODULE: 'module',
  H: 'h',
  V: 'v',
  FLUID: 'fluid',
  PASSEPARTOUT: 'passepartout',
  PASSEPARTOUTLARGE: 'passepartout-large',
  PILL: 'pill',
  CLOSABLE: 'closable',
} as const;
export type ContainerType = (typeof ContainerTypeValues)[keyof typeof ContainerTypeValues];

export const ContainerPositionValues = {
  STATIC: 'static',
  RELATIVE: 'relative',
} as const;
export type ContainerPosition = (typeof ContainerPositionValues)[keyof typeof ContainerPositionValues];
